import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {AppLanguageService} from './i18n/app.language.service';
import {TitleService} from './modules/common/services/title.service';
import {NgSelectConfig} from '@ng-select/ng-select';
import {Localization} from './modules/common/enums/localization';
import {BusinessRulesService} from './services/business-rules.service';
import {AuthenticationService} from './modules/common/services/authentication/authentication.service';
import {AppConfig} from './config/app.config';
import {FreshdeskWidgetManager, RequestErrorModalComponent} from '@npm.chapps.com/chapps.common.angular.library';
import {LoggerService} from './logger/LoggerService';
import {Subscription} from 'rxjs';
import {SystemNotificationsService} from "./modules/system-notifications/system-notifications.service";
import {map, take} from "rxjs/operators";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {

  @ViewChild(RequestErrorModalComponent) requestErrorModal: RequestErrorModalComponent;
  unselectTopNavButtons: boolean;
  subscription: Subscription;
  areTranslationsLoading: boolean;
  areBusinessRulesLoading: boolean;
  public readonly Localization = Localization;
  public readonly hasSystemNotifications$ = this.systemNotifications.active$.pipe(map(notifications => notifications?.length > 0))

  constructor(private router: Router, private translate: TranslateService, private titleService: TitleService, private appConfig: AppConfig,
              private langService: AppLanguageService, private config: NgSelectConfig, private businessRulesService: BusinessRulesService,
              private authenticationService: AuthenticationService, private logger: LoggerService, private freshdeskWidget: FreshdeskWidgetManager,
              private systemNotifications: SystemNotificationsService) {
    this.authenticationService.setTokens();
    this.initFreshDeskWidget();
    this.initTranslations();
    this.initBusinessRules();
    this.translate.get(Localization.NoItemsFound).subscribe(value => this.config.notFoundText = value);
    this.logger.error$.subscribe(() => this.requestErrorModal.show());
  }

  ngOnInit() {
    window.name = this.appConfig.TAB_NAME;
    this.unselectTopNavButtons = false;
    this.titleService.init();
  }

  public isUserLoggedIn(): boolean {
    return this.authenticationService.isUserLoggedIn();
  }

  private initTranslations() {
    this.areTranslationsLoading = true;
    this.langService.getStartingLanguage().pipe(take(1)).subscribe(l => {
      const lang = l.split('-')[0];
      this.translate.use(lang).subscribe(() => {
        this.areTranslationsLoading = false;
      });
    })
  }

  private initBusinessRules() {
    this.areBusinessRulesLoading = true;
    this.businessRulesService.init().subscribe(() => {
      this.areBusinessRulesLoading = false;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private initFreshDeskWidget() {
    this.translate.onLangChange.subscribe(change => this.freshdeskWidget.initalise(change.lang));
  }
}
